import http from './http'
import upload from './upload'

export const requestApi = (url, params, method = 'GET', headers = {}) => {
  if (method === 'GET') {
    return http.request({
      url: url,
      params: params,
      method: method
    })
  }
  return http.request({
    url: url,
    data: params,
    method: method
  })
}

export const requestUpload = (url, file, params = {}, config = {}) => {
  const formData = new FormData();
  formData.append('image', file)

  return upload.post(url, formData, config)
}

export const getAuthNode = () => {
  return http.request({
    url: 'admin/menus',
    method: 'GET'
  })
}


export const hasStorageItem = (key) => {
  let data = window.localStorage.getItem(key);
  return data !== null;
}

export const getStorageItem = (key) => {
  let data = window.localStorage.getItem(key);
  return JSON.parse(data)
}

export const setStorageItem = (key, data) => {
  data = JSON.stringify(data);
  window.localStorage.setItem(key, data);
}

export const removeStorageItem = (key) => {
  window.localStorage.removeItem(key);
};
